import React from "react"
import g from "glamorous"
import { rhythm } from "../utils/typography"
import mediaQueries from "../utils/breakpoints"

export default g.div({
    margin: `0 auto`,
    maxWidth: `1160px`,
    padding: rhythm(1),
    paddingTop: rhythm(3),
    position: `relative`,
    [mediaQueries.phone]: {
        
    }
})


// WEBPACK FOOTER //
// ./src/components/page-container.jsx